import { render, staticRenderFns } from "./GBreadcrumbs.vue?vue&type=template&id=2f30ad6f&"
import script from "./GBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./GBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./GBreadcrumbs.vue?vue&type=style&index=0&id=2f30ad6f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports